module.exports = __webpack_public_path__ + "img/settings_edit_users.825a157e.png";